import { MILLISECONDS_IN_SECOND } from "../unit-utils";

export function addSeconds(oldDate: Date, secondsToAdd: number): Date {
    return new Date(oldDate.getTime() + secondsToAdd * MILLISECONDS_IN_SECOND);
}
